import React from 'react'

import CardWithLabeledRowsOfButtons from 'pages/Dashboard/cards/shared/CardWithLabeledRowsOfButtons'

import { color } from 'styles/colors'
import ServiceContractsIcon from 'pages/shared/ServiceContractsIcon'

type Props = {
  activeServiceContractCount: number | string
  expiredServiceContractCount: number | string
  nonServiceContractCount: number | string
  isLoaded: boolean,
  hehmEnabled?: boolean
}
const ServiceContractsCard = ({ activeServiceContractCount, expiredServiceContractCount, nonServiceContractCount, isLoaded = true, hehmEnabled = false }: Props) => {
  return (
    <CardWithLabeledRowsOfButtons
      icon={
        <img
          src="/img/contract.svg"
          alt="Contract Icon"
          style={{ marginRight: '15px' }}
        />
      }
      title={ServiceContractsCard.cardTitle}
      subTitle="Devices can be manually identified in Diagnostics as having a Service Contract. There is currently no integration for these devices with any field service management tools."
      rows={[
        {
          label: '',
          buttons: [
            {
              text: 'Active',
              icon: <ServiceContractsIcon hasActiveContract hasExpiredContract={false} size={'34px'} />,
              quantity: activeServiceContractCount,
              accentColor: color('serviceContractActive'),
              apptentiveEventName: 'view_active_service_contract_devices',
              filter: 'active',
              tooltip: 'Total number of devices that have an active service contract.'
            },
            {
              text: 'Expired',
              icon: <ServiceContractsIcon hasActiveContract={false} hasExpiredContract size={'34px'} />,
              quantity: expiredServiceContractCount,
              accentColor: color('serviceContractExpired'),
              apptentiveEventName: 'view_expired_service_contract_devices',
              filter: 'expired',
              tooltip: 'Total number of devices that have an expired service contract.'
            },
            {
              text: 'No Contract',
              icon: <ServiceContractsIcon hasActiveContract={false} hasExpiredContract={false} size={'34px'} />,
              quantity: nonServiceContractCount,
              accentColor: color('serviceContractNone'),
              apptentiveEventName: 'view_no_service_contract_devices',
              filter: 'no_contract',
              tooltip: 'Total number of devices that do not have a service contract.'
            }
          ]
        }
      ]}
      isLoaded={isLoaded}
      hehmEnabled={hehmEnabled}
    />
  )
}

ServiceContractsCard.cardTitle = 'Service Contracts'
ServiceContractsCard.cardKey = 'service_contracts'

export default ServiceContractsCard
